import CategoryForm from './category-form';

export default CategoryForm;
